import { Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function ModifierApplyTo() {
    const { target, refresh } = useBoundContext()
    if (target.type !== "percentage") return null

    return (
        <FormControl>
            <FormLabel>Calculation basis</FormLabel>
            <RadioGroup
                value={target.applyTo || "running"}
                onChange={(e) => {
                    target.applyTo = e.target.value
                    refresh()
                }}
            >
                <FormControlLabel
                    value="running"
                    control={<Radio />}
                    label={
                        <Box>
                            <Typography variant="body2">Compound with other modifiers</Typography>
                            <Typography variant="caption" color="text.secondary">
                                Applies to the running total, so earlier modifiers affect this one.
                            </Typography>
                        </Box>
                    }
                />
                <FormControlLabel
                    data-cy="modifier-apply-to-base"
                    value="base"
                    control={<Radio />}
                    label={
                        <Box>
                            <Typography variant="body2">Apply to base cost only</Typography>
                            <Typography variant="caption" color="text.secondary">
                                Applies to the original subtotal before any other modifiers.
                            </Typography>
                        </Box>
                    }
                />
            </RadioGroup>
        </FormControl>
    )
}
